import { defineTokens } from '@chakra-ui/react/styled-system';

export const spacing = defineTokens.spacing({
	'0.75': { value: '0.1875rem' }, // 3px
	'1': { value: '0.25rem' }, // 4px
	'1.5': { value: '0.375rem' }, // 6px
	'4.5': { value: '1.125rem' }, // 18px
	'5.5': { value: '1.375rem' }, // 22px
	'11.25': { value: '2.8125rem' }, // 45px
	'15': { value: '3.75rem' }, // 60px
	'18': { value: '4.5rem' }, // 72px
	'20': { value: '5rem' }, // 80px
	'21': { value: '5.25rem' }, // 84px
	'22.5': { value: '5.625rem' }, // 90px
	'26': { value: '6.5rem' }, // 104px
	'27.5': { value: '6.875rem' }, // 110px
	'29': { value: '7.25rem' }, // 116px
	'30': { value: '7.5rem' }, // 120px
});